import { useLiveRef } from 'base/useLiveRef';
import { useEffect } from 'react';

/**
 * Execute {@link callback} exactly once on mount. Referential changes to
 * {@link callback} will not cause it to be invoked again.
 */
export function useOnMount(callback: () => void) {
  const callbackRef = useLiveRef(callback);
  useEffect(() => {
    callbackRef.current();
  }, [callbackRef]);
}
